import { SignInState } from "../Components/signInState";
import { Alert, CreateAlertRequest } from "../Types/alert";

declare let $: any;

/**
 * Validates if a string is a valid GUID format.
 * Format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx (8-4-4-4-12 hex characters)
 */
export const isValidGuid = (value: string): boolean => {
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return guidRegex.test(value);
};

/**
 * Extracts the error message from the API error response.
 * Parses JSON responses to extract the most specific error message available.
 * Recognises the .NET backend's ErrorResponse envelope (errorMessage / ErrorMessage)
 * in addition to the legacy { error } / { message } shapes.
 */
export const getErrorMessage = (errorText: string): string => {
  try {
    const parsed = JSON.parse(errorText);
    return parsed.error
      || parsed.message
      || parsed.errorMessage
      || parsed.ErrorMessage
      || errorText;
  } catch {
    return errorText;
  }
};

export const checkAccessTokenExpiry = async (accessToken: string) => {
  // Split the token into parts
  const payload = accessToken.split('.')[1];
  // Base64 decode the payload
  const decodedPayload = atob(payload);
  // Parse the decoded payload to get an object
  const payloadObj = JSON.parse(decodedPayload);
  // Get the expiration time from the payload
  const exp = payloadObj.exp;
  return exp;
}

export const addAlertMenuItemToVisualization = (revealView: any, signInState: SignInState, setCurrentAlert: (alert: Alert | CreateAlertRequest) => void) => {
  const existingOnMenuOpening = revealView.onMenuOpening;

  revealView.onMenuOpening = function (visualization: any, args: any) {
    if (typeof existingOnMenuOpening === 'function') {
      existingOnMenuOpening(visualization, args);
    }

    if (!Array.isArray(args?.menuItems)) {
      return;
    }

    for (let i = args.menuItems.length - 1; i >= 0; i -= 1) {
      if (args.menuItems[i]?.title === "Create Alert") {
        args.menuItems.splice(i, 1);
      }
    }
  }
}